import { render, staticRenderFns } from "./FollowupForm.vue?vue&type=template&id=3c3117d2&scoped=true&"
import script from "./FollowupForm.vue?vue&type=script&lang=js&"
export * from "./FollowupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3117d2",
  null
  
)

export default component.exports